function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import './RadioInputGroup.css';
import whitelistProps from '../../utils/whitelistProps';
import noop from '../../utils/noop';
import cs from 'classnames';
import FormLabel from '../FormLabel/FormLabel';
import withInputContainer from '../withInputContainer/withInputContainer';
import Fieldset from '../Fieldset/Fieldset';
import { RadioInput } from '../RadioInput/RadioInput';
import ThemeContext from '../../ThemeContext';
var whitelist = whitelistProps();
export function RadioInputGroup(_ref) {
  var options = _ref.options,
    _ref$metaType = _ref.metaType,
    metaType = _ref$metaType === void 0 ? 'boolean' : _ref$metaType,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'radiogroupoption' : _ref$type,
    auto = _ref.auto,
    description = _ref.description,
    iconIds = _ref.iconIds,
    errorId = _ref.errorId,
    errorMsg = _ref.errorMsg,
    width = _ref.width,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    id = _ref.id,
    value = _ref.value,
    checked = _ref.checked,
    name = _ref.name,
    style = _ref.style,
    required = _ref.required,
    disabled = _ref.disabled,
    readonly = _ref.readonly,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    view = _ref.view,
    attrs = _objectWithoutProperties(_ref, ["options", "metaType", "type", "auto", "description", "iconIds", "errorId", "errorMsg", "width", "size", "id", "value", "checked", "name", "style", "required", "disabled", "readonly", "onBlur", "onChange", "onFocus", "view"]);
  var theme = useContext(ThemeContext);
  var styl = width ? Object.assign({}, style, {
    width: width
  }) : style;
  var len = options.length;
  return /*#__PURE__*/React.createElement("div", {
    className: cs("_dm-radiogroup__options", "_dm-radiogroup__options--".concat(size), "_dm-radiogroup__options--".concat(theme), "_dm-radiogroup__options--".concat(theme, "--").concat(size), "auto-radiogroup")
  }, options.map(function (option) {
    var key = "".concat(id, "-").concat(option.value);
    var _readonly = readonly || option.readonly;
    var _disabled = disabled || option.disabled;
    return /*#__PURE__*/React.createElement("div", {
      className: cs("_dm-radiogroup__option", "_dm-radiogroup__option--".concat(size), "_dm-radiogroup__option--count-".concat(len), "_dm-radiogroup__option--count-".concat(len, "--").concat(size)),
      key: key
    }, view === 'PRINT' ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: option.label
      }
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioInput, Object.assign({
      id: key,
      value: option.value,
      checked: value === option.value,
      name: name,
      auto: auto,
      style: styl,
      size: "small",
      disabled: _disabled,
      "aria-disabled": _disabled,
      readonly: _readonly,
      onBlur: onBlur,
      onChange: _readonly || _disabled ? noop : onChange,
      onFocus: onFocus,
      "aria-describedby": "".concat(iconIds, " ").concat(errorId),
      "aria-invalid": !!errorMsg,
      "aria-errormessage": errorId
    }, whitelist(attrs))), /*#__PURE__*/React.createElement(FormLabel, {
      metaType: metaType,
      type: 'radio',
      htmlFor: key,
      i18n: option.label,
      size: 'small',
      theme: theme
    })));
  }));
}
export default withInputContainer({
  type: 'radiogroup',
  // fieldsets can't be grid containers, so we must put a div as a direct child
  // to take on the role of input container
  // see: https://github.com/rachelandrew/gridbugs#10-some-html-elements-cant-be-grid-containers
  element: Fieldset
})(RadioInputGroup);